export default './ServiceRequestCard';

export ServiceRequestCard from './ServiceRequestCard';



// WEBPACK FOOTER //
// ./components/ServiceRequestDisplayElement/index.js